import { StaticLinkForm } from '../staticLinkForm/StaticLinkForm'
import { StaticLinkFormTranslationKeys } from '../staticLinkForm/StaticLinkForm.types'

import { EditStaticLinkProps } from './EditStaticLink.types'

const translationKeys: StaticLinkFormTranslationKeys = {
  title: 'typography.editStaticLink',
  submitButton: 'button.save',
  successTitle: 'dialog.editStaticLink.success.title',
  successDescription: 'dialog.editStaticLink.success.description',
  errorTitle: 'dialog.editStaticLink.error.title',
  errorDescription: 'dialog.editStaticLink.error.description'
}

export function EditStaticLink({
  configurations,
  isLoadingConfigurations,
  onSubmit,
  isSaving,
  slugConfigModalStatus,
  setSlugConfigModalStatus,
  staticLink
}: Readonly<EditStaticLinkProps>) {
  const configurationOptions = configurations.map(config => ({
    value: config.id,
    label: config.name || config.id
  }))

  const defaultConfigurationOption = configurationOptions.find(
    opt => opt.value === staticLink.validationSubmissionConfigurationId
  )

  return (
    <StaticLinkForm
      configurations={configurations}
      isLoadingConfigurations={isLoadingConfigurations}
      onSubmit={onSubmit}
      isSaving={isSaving}
      translationKeys={translationKeys}
      slugConfigModalStatus={slugConfigModalStatus}
      setSlugConfigModalStatus={setSlugConfigModalStatus}
      defaultValues={{
        slug: staticLink.slug,
        validationSubmissionConfigurationId: staticLink.validationSubmissionConfigurationId,
        redirectUrl: staticLink.redirectUrl ?? '',
        isEnabled: staticLink.isEnabled,
        enablePost: staticLink.enablePost,
        allowedOrigin: staticLink.allowedOrigin ?? ''
      }}
      defaultConfigurationOption={defaultConfigurationOption}
    />
  )
}
